import { Button, Input, message, Popconfirm, Space, Table } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint'; // Responsive için

const AdminManager = () => {
  const [dataSource, setdataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const screens = useBreakpoint(); // Ekran genişliği kontrolü

  const columns = [
    {
      title: 'Resim',
      dataIndex: 'img',
      key: 'img',
      render: (imgSrc) => (
        <img
          style={{
            borderRadius: "50%",
            objectFit: "cover",
          }} 
          src={imgSrc} 
          width={50} // Küçük ekranlar için optimize edildi
          height={50}
          alt='manager'
        />
      ),
      responsive: ['sm', 'md', 'lg'], // XS ekranlarda gizle
    },
    {
      title: 'İsim/Soyisim',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <b>{text}</b>,
      responsive: ['xs', 'sm', 'md', 'lg'], // Her ekranda göster
    },
    {
      title: 'Makam',
      dataIndex: 'department',
      key: 'department',
      render: (text) => <b>{text}</b>,
      responsive: ['sm', 'md', 'lg'], // Küçük ekranlarda gösterilebilir
    },
    {
      title: 'Oluşturulma Tarihi',
      dataIndex: 'createdAt',
      key: 'createdAt',
      responsive: ['md', 'lg'], // Sadece orta ve büyük ekranlarda göster
    },
    {
      title:"Sil",
      dataIndex:"sil",
      key:"sil",
      render: (_, record) => (
        <Space size={"middle"}>
          <Button onClick={() => navigate(`/admin/manager/update/${record.id}`)} type='primary'>
            Düzenle
          </Button>
          <Popconfirm
            title="Kategori Sil"
            description="Kategoriyi silmek istediğinizden emin misiniz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => deleteManager(record.id)}
          >
            <Button type='primary' danger>Sil</Button>
          </Popconfirm>
        </Space>
      ),
      responsive: ['xs', 'sm', 'md', 'lg'], // Her ekranda göster
    }
  ];

  const deleteManager = async (managerId) => {
    try {
      const response = await fetch(`${apiUrl}/api/manager/${managerId}`, {
        method: "DELETE",
      });

      if (response.ok) {
        fetchManager();
        message.success("Yönetici başarıyla silindi");
      } else {
        message.error("Yönetici Silme İşlemi Başarısız.");
      }
    } catch (error) {
      console.log("Silme Hatası", error);
    }
  };

  const fetchManager = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/manager`);
      if (response.ok) {
        const data = await response.json();
        const filteredManagers = data.filter(manager => manager.boardType === "management");
        setdataSource(filteredManagers);
        setFilteredData(filteredManagers);
      } else {
        message.error("Yöneticiler Getirilemedi");
      }
    } catch (error) {
      console.log(error);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchManager();
  }, [fetchManager]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = dataSource.filter(
      (item) => item.name.toLowerCase().includes(value) || 
                item.department.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <>
      <Input
        placeholder="Yönetici ismi veya makam ara..."
        value={searchText}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: screens.xs ? '100%' : 300 }}
      />
      
      <Table
        rowKey={(record) => record.id} 
        dataSource={filteredData} 
        columns={columns}
        scroll={{ x: 'max-content' }} // Mobilde yatay kaydırmayı aktif ettik
      />
    </>
  );
};

export default AdminManager;
